export const MOON_ICON_MAP = {
  F: 'f',
  FQ: 'fq',
  LQ: 'lq',
  N: 'n',
  WNC: 'wnc',
  WNG: 'wng',
  WXC: 'wxc',
  WXG: 'wxg',
} as const;
